import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { InputField } from "../../../../../components/controls/InputField";
import { useValidationManager } from "../../../../../hooks/useValidation";
import { useHookstate } from "@hookstate/core";
import globalAuthStateStore from "../../../../../stores/globalAuthStateStore";
import { VirtualLibrarianService } from "../../../../../services/VirtualLibrarianService";
import HistoryIcon from "./HistoryIcon";
import DisallowedTopics from "./DisallowedTopics";

export default function PromptContent({
  selectedGuardrail,
  organization,
  setSelectedView,
  handlePublishButton,
}) {
  const [itemData, setItemData] = useState({ UniqueId: selectedGuardrail?.id });
  const validationManager = useValidationManager(false, ["GUARDRAIL"]);
  const [forceValidation, setForceValidation] = useState(false);
  const [saving, setSaving] = useState(false);
  const [onLoading, setOnLoading] = useState(false);
  const [onLoadingError, setOnLoadingError] = useState(false);
  const [onSave, setOnSave] = useState(false);
  const [onErrors, setOnErrors] = useState(false);
  const [onValidationErrors, setOnValidationErrors] = useState(false);
  const [onCancel, setOnCancel] = useState(false);

  const authStore = useHookstate(globalAuthStateStore);
  const vlService = React.useMemo(
    () => new VirtualLibrarianService(authStore),
    [authStore]
  );

  useEffect(() => {
    const screenData = sessionStorage.getItem("screen-data");
    const fetchGuardrail = async () => {
      setOnLoading(true);
      const result = await vlService.getVirtualLibrarianGuardrail(
        selectedGuardrail?.id
      );
      if (result.Success && result.Data) {
        console.log("Guardrails fetched successfully:", result);
        setItemData(result.Data);
        saveItemInStorage(result.Data);
        setOnLoading(false);
      } else if (onLoadingError) {
        onLoadingError(result.DisplayMessage);
      }
      setOnLoading(false);
    };
    if (screenData) {
      setItemData(JSON.parse(screenData));
    } else {
      if (vlService && selectedGuardrail?.id) {
        fetchGuardrail();
      } else {
        setItemData({
          UniqueId: selectedGuardrail?.id,
          isActive: true,
          promptType: "Custom",
        });
      }
    }
  }, [selectedGuardrail?.id]);

  const saveItemInStorage = (item) => {
    sessionStorage.setItem("screen-data", JSON.stringify(item));
  };

  const handleOnChange = (value, field) => {
    const updatedItemData = { ...itemData };
    updatedItemData[field] = value;
    saveItemInStorage(updatedItemData);
    setItemData(updatedItemData);
  };

  const handleOnSave = async () => {
    const errors = validationManager.checkIsGroupValid(itemData);
    const saveGuardrail = async () => {
      if (onSave) setSaving(true);
      const result = selectedGuardrail?.id
        ? await vlService.saveGuardrail(selectedGuardrail?.id, itemData)
        : await vlService.createGuardrail(itemData);
      if (result.Success && result.Data) {
        console.log("Guardrail saved successfully:", result);
        onSave(result.Data);
        setSaving(false);
      } else if (onErrors) {
        onErrors([result.DisplayMessage]);
        setSaving(false);
      }
    };

    if (errors.length === 0) {
      saveGuardrail(selectedGuardrail?.id, itemData);
    } else if (onValidationErrors) {
      onValidationErrors(errors);
      validationManager.setForceValidate(true);
      setForceValidation(true);
    }
  };

  const handleOnCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const handleDisallowedTopics = () => {
    if (organization?.value?.length > 0) {
      return (
        <>
          <DisallowedTopics
            guardrail={selectedGuardrail}
            isMasterPrompt={false}
            promptHeader="Disallowed Topics"
            onSave={handleOnSave}
          />
          <DisallowedTopics
            guardrail={selectedGuardrail}
            isMasterPrompt={false}
            promptHeader="Additional Topics"
            organization={organization}
            onSave={handleOnSave}
            handlePublishButton={handlePublishButton}
          />
        </>
      );
    } else {
      return (
        <DisallowedTopics
          guardrail={selectedGuardrail}
          isMasterPrompt={true}
          promptHeader="Disallowed Topics"
          onSave={handleOnSave}
          handlePublishButton={handlePublishButton}
        />
      );
    }
  };
  return (
    <div className="prompt-content">
      <div className="prompt-list-header">
        <h5>
          Prompt Content
          {organization?.value?.length > 0 ? ": " + organization?.label : ""}
        </h5>
        {selectedGuardrail?.promptTitle === "Disallowed Topics" && (
          <button
            className="history-icon-container"
            onClick={() => setSelectedView()}
          >
            <HistoryIcon className="history-icon" />
          </button>
        )}
      </div>
      {selectedGuardrail?.promptTitle === "Disallowed Topics" ? (
        handleDisallowedTopics()
      ) : (
        <div className="prompt-content-body">
          <h4>{selectedGuardrail?.promptTitle}</h4>
          <ReactMarkdown>
            {(selectedGuardrail?.promptContent &&
              (selectedGuardrail.promptContent.indexOf("\n") !== -1
                ? selectedGuardrail.promptContent.substring(
                    selectedGuardrail.promptContent.indexOf("\n") + 1
                  )
                : selectedGuardrail.promptContent)) ||
              "*No content provided*"}
          </ReactMarkdown>
        </div>
      )}
    </div>
  );
}
